module.exports = __webpack_public_path__ + "static/portico_01-f22c2c9f683db4ea558c54d9d9e4dc9f.webp";